import { useEffect, useState ,useRef} from "react";
import {
  Button,
  Checkbox,
  Input,
  Modal,
  Radio,
  message,
  Row,
  Col,
  Select,
} from "antd";

import { useTranslation } from "react-i18next";
import { useDispatch,useSelector } from "react-redux";
import { setshowDivsConditions } from "../../redux/actions";
import { LinkOutlined,LoadingOutlined,DownloadOutlined } from "@ant-design/icons";

import QRCode from "react-qr-code";
import html2canvas from 'html2canvas';
import { useMediaQuery } from "@material-ui/core";

const ModalExport = ({
  visible,
  handleCancel,
  GetVideoLinks,
  loadingLinks,
}) => {
  const { TextArea } = Input;
  const dispatch = useDispatch();
  const { t } = useTranslation(); // translation
  const [valueRadioButton] = useState("auto"); // take value of radio button in modal Embed Code
  const linkIntranet =
    GetVideoLinks?.[valueRadioButton]?.permaLink?.permaLink?.intranet;
  const linkInternet =
    GetVideoLinks?.[valueRadioButton]?.permaLink?.permaLink?.internet;
  const srtLink = GetVideoLinks?.srtLink;
  const srtLink2 = GetVideoLinks?.srtLink2;
  const rtmpLink = GetVideoLinks?.rtmpLink;
  const rtmpLink2 = GetVideoLinks?.rtmpLink2;

  const videoUrl = GetVideoLinks?.videoUrl;

  const enabledYTB = useSelector(state=>state.reducer.selectedYTB)
  const [btnModalactive, setbtnModalactive] = useState(false); //add active class to btn modal
  useEffect(() => {
    linkInternet
      ? setbtnModalactive(false)
      : linkIntranet
      ? setbtnModalactive(true)
      : setbtnModalactive(false);
  }, [linkInternet, linkIntranet]);
  const [valuecheckboxautoplay, setvaluecheckboxautoplay] = useState(false); // take value of checkbox autoplay modal
  const addedtext = "?a=1"; // texte a ajouter dans le champ permalien et lien d'intégration si on check autoplay
  // active btn intranet modal embed code
  const handlebtnintranet = (e) => {
    setbtnModalactive(true);
    dispatch(
      setshowDivsConditions({
        showDivsConditionsName: "valuecheckboxCDN",
        showDivsConditionsValue: false,
      })
    );
  };

  // get value of checkbox Modal Embed Code
  const onChangecheckboxAutoplay = (e) => {
    setvaluecheckboxautoplay(e.target.checked);
  };
  // Copy text Input text Moda embed code
  const copyTextInput = () => {
    if (!document.getElementById("myInp").value) {
      return message.error({
        content: `${t("Message.PermalinkMessageVide")}`,
        duration: 1.5,
      });
    } else {
      setCode(document.getElementById("myInp").value);
      document.getElementById("myInp").select();
      document.execCommand("Copy");
      message.success({
        content: `${t("Message.CopiePermalink")}`,
        duration: 1.5,
      });
    }
  };
  const copyTextFlowInput = () => {
    if (!document.getElementById("myInpFlow").value) {
      return message.error({
        content: `${t("Message.FlowLinkkMessageVide")}`,
        duration: 1.5,
      });
    } else {
      setCode(document.getElementById("myInpFlow").value);
      document.getElementById("myInpFlow").select();
      document.execCommand("Copy");
      message.success({
        content: `${t("Message.CopieFlowlink")}`,
        duration: 1.5,
      });
    }
  };
  const copySRTPrimary = () => {
    if (!document.getElementById("srtPrimary").value) {
      return message.error({
        content: `${t("Message.LinkSRTMessageVide")}`,
        duration: 1.5,
      });
    } else {
      setCode(document.getElementById("srtPrimary").value);
      document.getElementById("srtPrimary").select();
      document.execCommand("Copy");
      message.success({
        content: `${t("Message.CopieLinkSRT")}`,
        duration: 1.5,
      });
    }
  };
  const copySRTSecondary = () => {
    if (!document.getElementById("srtSecondary").value) {
      return message.error({
        content: `${t("Message.LinkSRTMessageVide")}`,
        duration: 1.5,
      });
    } else {
      setCode(document.getElementById("srtSecondary").value);
      document.getElementById("srtSecondary").select();
      document.execCommand("Copy");
      message.success({
        content: `${t("Message.CopieLinkSRT")}`,
        duration: 1.5,
      });
    }
  };
  const copyRTMPprimary = () => {
    if (!document.getElementById("rtmpPrimary").value) {
      return message.error({
        content: `${t("Message.LinkRTMPMessageVide")}`,
        duration: 1.5,
      });
    } else {
      setCode(document.getElementById("rtmpPrimary").value);
      document.getElementById("rtmpPrimary").select();
      document.execCommand("Copy");
      message.success({
        content: `${t("Message.CopieLinkRTMP")}`,
        duration: 1.5,
      });
    }
  };
  const copyRTMPsecondary = () => {
    if (!document.getElementById("rtmpSecondary").value) {
      return message.error({
        content: `${t("Message.LinkRTMPMessageVide")}`,
        duration: 1.5,
      });
    } else {
      setCode(document.getElementById("rtmpSecondary").value);
      document.getElementById("rtmpSecondary").select();
      document.execCommand("Copy");
      message.success({
        content: `${t("Message.CopieLinkRTMP")}`,
        duration: 1.5,
      });
    }
  };

  // copy Text Area Modal Embed Code
  const copyTextArea = () => {
    if (document.getElementById("myTextArea").value === "") {
      return message.error({
        content: `${t("Message.LienVide")}`,
        duration: 1.5,
      });
    } else {
      setCode(document.getElementById("myTextArea").value);
      document.getElementById("myTextArea").select();
      document.execCommand("Copy");
      message.success({ content: `${t("Message.CopieLink")}`, duration: 1.5 });
    }
  };
  const [selectedValue, setSelectedValue] = useState("");

  const [languageUrl, setLanguageUrl] = useState("");
  const [link, setLink] = useState("");

  useEffect(() => {
    const linksArray = GetVideoLinks?.youtubeLinks?.links || [];
    const defaultLanguage = linksArray?.length > 0 ? linksArray[0]?.lang : "";
    const defaultLink = linksArray?.length > 0 ? linksArray[0]?.link : "";
    setLanguageUrl(defaultLanguage);
    setLink(defaultLink);
  }, [GetVideoLinks?.youtubeLinks?.links]);

  useEffect(() => {
    const textAreaElement = document.getElementById("youtube");

    if (textAreaElement) {
      const selectedLink = GetVideoLinks?.youtubeLinks?.links?.find(
        (link) => link.lang === languageUrl
      );
      if (selectedLink) {
        textAreaElement.value = selectedLink.link;
        setLink(selectedLink.link);
      } else {
        textAreaElement.value = "";
        setLink("");
      }
    }
  }, [languageUrl, GetVideoLinks?.youtubeLinks?.links]);

  const copyTextYoutube = () => {
    if (document.getElementById("youtube").value === "") {
      return message.error({
        content: `${t("Message.LienVide")}`,
        duration: 1.5,
      });
    } else {
      setCode(document.getElementById("youtube").value);
      document.getElementById("youtube").select();
      document.execCommand("Copy");
      message.success({ content: `${t("Message.CopieLink")}`, duration: 1.5 });
    }
  };
const { Option } = Select;
 const [openDropdown,setOpenDropdown] = useState(false)

const menu = (
  <Select
    defaultValue={selectedValue || `${t("Modal.select_link")}`}
    value={selectedValue || `${t("Modal.select_link")}`}
    style={{ width: 180 }}
    onSelect={(value) => {
      setSelectedValue(value);
      setOpenDropdown(false);
    }}
    dropdownRender={(menu) => (
      <div>
        {menu}
        <Radio.Group
          style={{ padding: "8px" }}
          onChange={(e) => {
            setSelectedValue(e.target.value);
            setOpenDropdown(false);
          }}
          defaultValue={selectedValue}
        >
          <Radio value="Lien SRT">
            <span style={{ marginLeft: "8px" }}>{t("Modal.LinkSRT")}</span>
          </Radio>
          <Radio value="Lien RTMP">
            <span style={{ marginLeft: "8px" }}>{t("Modal.LinkRTMP")}</span>
          </Radio>
        </Radio.Group>
      </div>
    )}
    open={openDropdown}
    onDropdownVisibleChange={(open) => setOpenDropdown(open)}
  >
    <Option value="Select" disabled style={{ display: "none" }}>
      {t("Modal.select_link")}
    </Option>
  </Select>
);
  const [code, setCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const sizeTablet = useMediaQuery("(max-width:600px)");
  useEffect(() => {
    if (GetVideoLinks?.youtubeLinks?.links?.length > 0 && link !== null) {
      setCode(link);
    } else if (linkInternet !== undefined) {
      setCode(linkInternet);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkInternet, link]);

  const qrCodeRef = useRef(null);
  const handleSaveImage = async () => {
    setIsLoading(true);
    try {
      if (qrCodeRef.current) {
        const canvas = await html2canvas(qrCodeRef.current, {
          width: 100,
          height: 100,
        });
        const dataUrl = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = dataUrl;
        a.download = "qrcode.png";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error("Erreur lors d'enregistrement d'image qrCode", error);
    } finally {
      setIsLoading(false);
    }
  };
if (loadingLinks) return <></>
  return (
    <>
      {enabledYTB > 0 ? (
        <Modal
          title={<div className="custom-modal-title">Code embed</div>}
          centered
          visible={visible}
          onCancel={handleCancel}
          width={646}
          height={720}
          padding={"10px"}
          footer={[
            <Button className="btn_fermer" key="back" onClick={handleCancel}>
              {t("Modal.close")}
            </Button>,
          ]}
        >
          <Row>
            <label> {t("Modal.SelectLanguage")}</label>
            <Col
              span={24}
              style={{
                display: "flex",
                gap: "10px",
                marginTop: "8px",
              }}
            >
              <Select
                style={{
                  width: "100%",
                }}
                className="here"
                onChange={(value) => setLanguageUrl(value)}
                value={languageUrl}
                options={GetVideoLinks?.youtubeLinks?.links?.map((link) => ({
                  value: link.lang,
                  label: link.lang.charAt(0).toUpperCase() + link.lang.slice(1),
                }))}
              />
            </Col>
          </Row>
          <Row>
            <label>{t("Modal.lien")} </label>
            <span
              style={{
                position: "relative",
                width: "100%",
              }}
            >
              <svg
                style={{
                  position: "absolute",
                  top: "7px",
                  right: "5px",
                  zIndex: "9",
                  cursor: "pointer",
                }}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                onClick={() => {
                  copyTextYoutube();
                }}
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.4615 0H7.13354C5.62544 0 4.43077 0 3.49621 0.128093C2.53456 0.260372 1.7559 0.538326 1.14133 1.16456C0.52759 1.79163 0.25518 2.58614 0.125539 3.56735C9.78128e-08 4.52177 0 5.73991 0 7.2787V12.3488C1.98066e-05 13.0968 0.261691 13.8202 0.737918 14.3889C1.21414 14.9575 1.87365 15.334 2.59774 15.4507C2.71015 16.0903 2.92759 16.6362 3.36246 17.0807C3.85641 17.5847 4.47836 17.8007 5.21682 17.9029C5.92821 18 6.83323 18 7.95487 18H10.5067C11.6283 18 12.5333 18 13.2447 17.9029C13.9832 17.8007 14.6051 17.5847 15.0991 17.0807C15.593 16.5767 15.8047 15.9421 15.9048 15.1887C16 14.4628 16 13.5393 16 12.3949V8.11674C16 6.97228 16 6.04884 15.9048 5.32298C15.8047 4.56949 15.593 3.93488 15.0991 3.43088C14.6634 2.98716 14.1284 2.7653 13.5015 2.6506C13.3872 1.91178 13.0182 1.23885 12.4609 0.752934C11.9036 0.267016 11.1946 2.02096e-05 10.4615 0ZM12.2092 2.52921C12.0845 2.15749 11.8489 1.83488 11.5355 1.60654C11.2221 1.37821 10.8466 1.25557 10.4615 1.25581H7.17949C5.61477 1.25581 4.5038 1.25749 3.65949 1.37302C2.83487 1.48605 2.35897 1.6987 2.0119 2.05284C1.66482 2.40698 1.45641 2.89256 1.34564 3.73479C1.23241 4.59544 1.23077 5.72902 1.23077 7.32558V12.3488C1.23053 12.7418 1.35072 13.1249 1.5745 13.4447C1.79828 13.7644 2.11446 14.0048 2.47877 14.1321C2.46154 13.6214 2.46154 13.0437 2.46154 12.3949V8.11674C2.46154 6.97228 2.46154 6.04884 2.55754 5.32298C2.656 4.56949 2.86933 3.93488 3.36246 3.43088C3.85641 2.92688 4.47836 2.71088 5.21682 2.60958C5.92821 2.51163 6.83323 2.51163 7.95487 2.51163H10.5067C11.1426 2.51163 11.7087 2.51163 12.2092 2.52921ZM4.23221 4.32C4.45949 4.08809 4.77785 3.9374 5.38092 3.85451C5.99959 3.76995 6.82174 3.76828 7.99918 3.76828H10.4607C11.6382 3.76828 12.4595 3.76995 13.0798 3.85451C13.6821 3.9374 14.0004 4.08893 14.2277 4.32C14.455 4.55191 14.6027 4.87674 14.6839 5.49209C14.7668 6.12335 14.7684 6.96223 14.7684 8.16363V12.3497C14.7684 13.5511 14.7668 14.3891 14.6839 15.022C14.6027 15.6366 14.4542 15.9614 14.2277 16.1933C14.0004 16.4252 13.6821 16.5759 13.079 16.6588C12.4595 16.7433 11.6382 16.745 10.4607 16.745H7.99918C6.82174 16.745 5.99959 16.7433 5.3801 16.6588C4.77785 16.5759 4.45949 16.4244 4.23221 16.1933C4.00492 15.9614 3.85723 15.6366 3.776 15.0212C3.69313 14.3891 3.69149 13.5511 3.69149 12.3497V8.16363C3.69149 6.96223 3.69313 6.12335 3.776 5.49126C3.85723 4.87674 4.00574 4.55191 4.23221 4.32Z"
                  fill="#6B6B89"
                />
              </svg>

              <input
                name="urlYoutube"
                type="text"
                id="youtube"
                className="ant-input"
                readOnly
              />
            </span>
          </Row>

          <Row
            style={{
              gap: ".75rem",
              flexWrap: sizeTablet ? "wrap" : "nowrap",
              flexDirection: sizeTablet ? "column" : "row",
              marginTop: "20px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Col
              span={sizeTablet ? 25 : 6}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {" "}
              <div style={{ position: "relative" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    ref={qrCodeRef}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <QRCode
                      size={100}
                      bgColor="white"
                      fgColor="black"
                      value={code === null ? <LoadingOutlined /> : code}
                    />
                  </div>
                </div>
                <span onClick={handleSaveImage} className="uploadBtn">
                  {isLoading ? <LoadingOutlined /> : <DownloadOutlined />}
                </span>
              </div>
            </Col>
          </Row>
          <LinkOutlined className="link_icon" />
        </Modal>
      ) : (
        <Modal
          title={<div className="custom-modal-title">Code embed</div>}
          centered
          visible={visible}
          onCancel={handleCancel}
          width={646}
          height={720}
          padding={"10px"}
          footer={[
            <Button className="btn_fermer" key="back" onClick={handleCancel}>
              {t("Modal.close")}
            </Button>,
          ]}
        >
          <div className="div_dropdown">{menu}</div>

          {selectedValue === "Lien SRT" && (
            <div>
              <div className="div_permalien">
                <h5>{t("Modal.primarylink")}</h5>
                <Button onClick={copySRTPrimary}>
                  {t("Modal.CopierPermalink")}
                </Button>
              </div>

              <Input
                id="srtPrimary"
                value={`${srtLink ? srtLink : ""}`}
                className="input_permalien"
              />

              <div className="div_permalien">
                <h5>{t("Modal.secondaryLink")}</h5>
                <Button onClick={copySRTSecondary}>
                  {t("Modal.CopierPermalink")}
                </Button>
              </div>

              <Input
                id="srtSecondary"
                value={`${srtLink2 ? srtLink2 : ""}`}
                className="input_permalien"
              />
            </div>
          )}

          {selectedValue === "Lien RTMP" && (
            <div>
              <div className="div_permalien">
                <h5>{t("Modal.primarylink")}</h5>
                <Button onClick={copyRTMPprimary}>
                  {t("Modal.CopierPermalink")}
                </Button>
              </div>

              <Input
                id="rtmpPrimary"
                value={`${rtmpLink ? rtmpLink : ""}`}
                className="input_permalien"
              />

              <div className="div_permalien">
                <h5>{t("Modal.secondaryLink")}</h5>
                <Button onClick={copyRTMPsecondary}>
                  {t("Modal.CopierPermalink")}
                </Button>
              </div>

              <Input
                id="rtmpSecondary"
                value={`${rtmpLink2 ? rtmpLink2 : ""}`}
                className="input_permalien"
              />
            </div>
          )}

          <p className="p_export">{t("Modal.ExportTitleAuto")}</p>
          <Row
            style={{
              gap: ".75rem",
              flexWrap: sizeTablet ? "wrap" : "nowrap",
              flexDirection: sizeTablet ? "column" : "row",
            }}
          >
            <Col span={sizeTablet ? 25 : 18}>
            <div className="div_flux">
                <h5>{t("Modal.FlowLink")}</h5>
                <Button onClick={copyTextFlowInput}>
                  {t("Modal.CopierPermalink")}
                </Button>
              </div>
              <Input
                id="myInpFlow"
                value={`${videoUrl
                  
                    ? videoUrl
                    : ""
                }`}
                className="input_flowlink"
              />
              <div className="div_permalien">
                {linkInternet && (
                  <h5>Internet</h5>
                )}
                 {linkIntranet && (
                  <Button
                    className="btn_intranet_modal"
                    onClick={handlebtnintranet}
                    id={btnModalactive === true ? "active" : ""}
                  >
                    Intranet
                  </Button>
                )} 
              </div>

              <div className="div_checkbox">
                <Checkbox id="check_box" onChange={onChangecheckboxAutoplay}>
                  {t("Modal.Autoplay")}
                </Checkbox>
              </div>

           

              <div className="div_permalien">
                <h5>{t("Modal.Permalien")}</h5>
                <Button onClick={copyTextInput}>
                  {t("Modal.CopierPermalink")}
                </Button>
              </div>
              <Input
                id="myInp"
                value={`${btnModalactive ? linkIntranet : linkInternet}${
                  (btnModalactive ? linkIntranet : linkInternet) &&
                  valuecheckboxautoplay
                    ? addedtext
                    : ""
                }`}
                className="input_permalien"
              />

              <div className="div_lienIntegration">
                <h5>{t("Modal.LienIntegartion")}</h5>
                <Button onClick={copyTextArea}>
                  {t("Modal.CopierPermalink")}
                </Button>
              </div>

              <TextArea
                id="myTextArea"
                className="text_area"
                value={
                  btnModalactive
                    ? GetVideoLinks?.[valueRadioButton]?.embed?.embedLink
                        ?.intranet
                    : GetVideoLinks?.[valueRadioButton]?.embed?.embedLink
                        ?.internet
                }
              />
            </Col>
            <Col
              span={sizeTablet ? 25 : 6}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {" "}
              <div style={{ position: "relative" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    ref={qrCodeRef}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <QRCode
                      size={100}
                      bgColor="white"
                      fgColor="black"
                      value={code === null ? <LoadingOutlined /> : code}
                    />
                  </div>
                </div>
                <span onClick={handleSaveImage} className="uploadBtn">
                  {isLoading ? <LoadingOutlined /> : <DownloadOutlined />}
                </span>
              </div>
            </Col>
          </Row>
          <LinkOutlined className="link_icon" />
        </Modal>
      )}
    </>
  );
};

export default ModalExport;
